import React, { useEffect, useRef } from 'react';

const WaveformVisualizer = ({ 
  currentTime = 0, 
  duration = 0, 
  chapters = [],
  isPlaying = false 
}) => {
  const canvasRef = useRef(null);
  const animationRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef?.current;
    if (!canvas) return;

    const ctx = canvas?.getContext('2d');
    const width = canvas?.width;
    const height = canvas?.height;

    const drawWaveform = () => {
      ctx?.clearRect(0, 0, width, height);

      const barWidth = 3;
      const barGap = 2;
      const barCount = Math.floor(width / (barWidth + barGap));
      const progress = duration > 0 ? currentTime / duration : 0;

      for (let i = 0; i < barCount; i++) {
        const x = i * (barWidth + barGap);
        const normalizedPosition = i / barCount;
        const barHeight = Math.sin(normalizedPosition * Math.PI * 4) * (height * 0.4) + (height * 0.3);
        const y = (height - barHeight) / 2;

        if (normalizedPosition <= progress) {
          ctx.fillStyle = 'var(--color-primary)';
        } else {
          ctx.fillStyle = 'var(--color-muted)';
        }

        ctx?.fillRect(x, y, barWidth, barHeight);
      }

      chapters?.forEach(chapter => {
        const chapterPosition = (chapter?.timestamp / duration) * width;
        ctx.fillStyle = 'var(--color-accent)';
        ctx?.fillRect(chapterPosition - 1, 0, 2, height);
      });

      if (isPlaying) {
        animationRef.current = requestAnimationFrame(drawWaveform);
      }
    };

    drawWaveform();

    return () => {
      if (animationRef?.current) {
        cancelAnimationFrame(animationRef?.current);
      }
    };
  }, [currentTime, duration, chapters, isPlaying]);

  return (
    <canvas
      ref={canvasRef}
      width={800}
      height={80}
      className="w-full h-20 rounded-lg"
      aria-label="Визуализация аудиоволны"
    />
  );
};

export default WaveformVisualizer;